import type { ApiResult } from '@/lib/apps/sdk';

// ============================================================================
// appSdkUtils.ts — хелперы единообразной работы с AppSDK ApiResult.
// Вызовы AppSDK возвращают {ok, value | error} (ошибки НЕ бросаются).
// unwrap: разворачивает результат; при ошибке вызывает onError (тост/лог)
// и возвращает null — без if-каскадов в приложениях.
// ============================================================================

// unwrap — развернуть ApiResult<T> в T|null (ошибка → onError → null).
export async function unwrap<T>(
  call: Promise<ApiResult<T>>,
  onError?: (error: string) => void,
): Promise<T | null> {
  const res = await call;
  if (res.ok) return res.value;
  onError?.(errorText(res.error));
  return null;
}

// errorText — текст ошибки из ApiResult.error (Error | string | unknown).
export function errorText(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: unknown }).message);
  }
  return String(error ?? 'Ошибка');
}
